export default "__VITE_ASSET__zjMEOsG2__"